import React from 'react';
import './ScheduleList.css';

import { Heading, Session } from '../../../components';
import { schedule } from '../../../constants';
import { groupSessionsByDate } from '../../../utils';



const ScheduleList = () => {

  const groupedSchedule = groupSessionsByDate(schedule); // Group sessions by date using the utility function

  return (

    <section className="schedule-list">

      <Heading title={'Event Schedule'} subTitle={'Your Guide to the Event'} />

      {/* Loop through each day with sessions */}
      {groupedSchedule.map((day, index) => (
        <div key={index} className="day-container">

          {/* Display Day and Date */}
          <div className="schedule-date">
            <h5>{day.day}</h5>
            <h2>{day.date}</h2>
          </div>

          {/* Render each session for the current day */}
          {day.sessions.map(session => (
            <Session key={session.id} session={session} />
          ))}

        </div>
      ))}

    </section>

  );
};

export default ScheduleList;